module.exports = __webpack_public_path__ + "static/fireplacestill-c1ac58f7300c155d5d83efff0dc7b370.jpg";